import { OutcropExamples } from '~/components/wiki/OutcropExamples';
import { useMemberDetailOutletContext } from '~/routes/wiki/regional/lithostrat/member.$memberId';

export default function MemberAnaloguesRoute() {
  const { member } = useMemberDetailOutletContext();
  return <OutcropExamples parentType="member" parent={member} />;
}
